// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e2d2d3d4","453":"aabb7d3f","667":"d3e815a0","831":"9e543514","977":"cea834fd"}[chunkId] + ".chunk.js";
};